export const CACHE_EXPIRE_TIME_S = 20 * 60; // Current Value = 20 min
export const DEFAULT_PAGINATION_SIZE = 1000;

export enum UnitsEnum {
  imperial = 'Imperial (US)',
  metric = 'Metric (Global)',
}
